import doc1 from '../../../assets/doctors/Dr-b-k-misra.png';
import doc2 from '../../../assets/doctors/Dr-Ashok-Kumar-Mahapatra.jpeg';
import doc3 from '../../../assets/doctors/Dr-chang-susan.jpg';
import doc4 from '../../../assets/doctors/Dr-Sandeep-Vaishya.jpg';
import doc5 from '../../../assets/doctors/Dr-KeithL.jpeg';
import doc6 from '../../../assets/doctors/Dr-Mithel.jpeg';

export const doctorsData = [
  {
    imgSrc: doc1,
    name: 'Dr. B. K. Misra',
    specialization: 'Neurosurgeon',
    description: 'Renowned for complex brain tumor surgeries, minimally invasive techniques, and over 30 years of experience.',
    location: 'P. D. Hinduja Hospital, Mumbai, India',
  },
  {
    imgSrc: doc2,
    name: 'Dr. Ashok K. Mahapatra',
    specialization: 'Neurosurgeon',
    description: 'Former HOD of Neurosurgery at AIIMS, known for pioneering work in neuro-oncology and brain tumor removal.',
    location: 'AIIMS, New Delhi, India',
  },
  {
    imgSrc: doc3,
    name: 'Dr. Susan Chang',
    specialization: 'Neuro-Oncologist',
    description: 'Internationally recognized expert in glioblastoma and brain tumor treatment, focusing on clinical trials and personalized medicine.',
    location: 'UCSF Medical Center, California, USA',
  },
  {
    imgSrc: doc4,
    name: 'Dr. Sandeep Vaishya',
    specialization: 'Neurosurgeon',
    description: 'One of India’s leading brain and spine surgeons, known for advanced microsurgical techniques.',
    location: 'Fortis Memorial Research Institute, Gurugram, India',
  },
  {
    imgSrc: doc5,
    name: 'Dr. Keith L. Black',
    specialization: 'Neurosurgery',
    description: 'Globally renowned for brain tumor treatment using AI, laser therapy, and immunotherapy.',
    location: 'Cedars-Sinai Medical Center, Los Angeles, USA',
  },
  {
    imgSrc: doc6,
    name: 'Dr. Mitchel S. Berger',
    specialization: 'Neurosurgeon',
    description: 'Pioneering neurosurgeon specializing in brain tumor surgery, known for innovative techniques and extensive research in neuro-oncology.',
    location: 'UCSF Medical Center, California, USA',

  }
];